import React, { Component } from "react";
import Collapse from "rc-collapse";
import Checkbox from "./Checkbox";
import "rc-collapse/assets/index.css";
const Panel = Collapse.Panel;

export default class AccordianTree extends Component {
  constructor(props) {
    super(props);

    this.state = {
      checkedKeys: this.props.checkedKeys,
      commonDrugs: []
    };

    this.handleChange = this.handleChange.bind(this);
  }

  //given a name, check if it's checked, i.e. in the checkedKeys
  isChecked(name) {
    return this.props.checkedKeys.includes(name);
  }

  handleChange(e) {
    const item = e.target.name;
    const isChecked = e.target.checked;
    if (isChecked) {
      const newKeys = [...this.props.checkedKeys, item];
      this.props.designatedHandler(newKeys);
    } else {
      const newKeys = this.props.checkedKeys.filter(function(key) {
        return key !== item;
      });
      this.props.designatedHandler(newKeys);
    }
  }

  renderTreeNodesRecursive = data => {
    return (
      <div className="accordion">
        <Collapse accordion={false}>
          {data.map(item => {
            return item.Med_Name.includes('Blank') ? (<div><div style={{'background-color':'white', 'height': '30px'}}></div>{this.renderTreeNodes(item.children)}</div>) :
            (<Panel
              key={item.Med_Name}
              header={this.abreviate(item.Med_Name)}
              headerClass="my-header-class"
            >
              {this.renderTreeNodes(item.children)}
            </Panel>)
          })}
        </Collapse>
      </div>
    );
  };

  abreviate = medclass => {
    var abv = medclass;
    switch (medclass) {
      case "Calcium Channel Blockers - DHPs":
        abv = "Ca Channel Blockers-DHPs";
        break;
      case "Calcium Channel Blockers - Non DHPs":
        abv = "Ca Channel Blockers-Non DHPs";
        break;
      default:
        break;
    }
    return abv;
  };

  renderTreeNodes = data => {
    return data.map(item => {
      return (
        <Checkbox
          key={item.Med_Name}
          name={item.Med_Name}
          checked={this.isChecked(item.Med_Name)}
          onChange={this.handleChange}
        />
      );
    });
  };

  buildTree = (options, type) => {
    //if true will be classes
    if (options || type === "addiction") {
      return this.renderTreeNodes(this.props.filterOptions);
    } else if (type === "diabetes" || "psychiatry") {

      return this.renderTreeNodesRecursive(this.props.filterOptions);
    } else if (type === "hypertension") {
      return this.renderTreeNodesRecursive(this.state.commonDrugs);
    } 
  };

  render() {
    return (
      <div>{this.buildTree(this.props.switchOption, this.props.type)}</div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/NavBar/SelectDialog/AccordianTree.js